// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Ids Loading Indicator */
:host(ids-loading-indicator:not([linear]):not([sticky])) {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

:host(ids-loading-indicator:not([linear]):not([sticky]):not([inline])) {
  width: 50px;
  height: 50px;
}

:host(ids-loading-indicator[inline]:not([linear]):not([sticky])) {
  width: 11px;
  height: 11px;
}

:host(ids-loading-indicator[align=center]:not([linear]):not([sticky]):not([inline])) {
  position: fixed;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  margin-block-start: -25px;
}

:host(ids-loading-indicator[align=center]:not([stopped])[contained]:not([sticky]):not([inline])) {
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

:host(ids-loading-indicator[stopped]:not([linear]):not([sticky])),
:host(ids-loading-indicator[stopped][linear]),
:host(ids-loading-indicator[stopped][sticky]) {
  display: none;
}

:host(ids-loading-indicator[linear]),
:host(ids-loading-indicator[sticky]) {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}

:host(ids-loading-indicator[sticky]) {
  position: absolute;
  align-items: center;
  top: 0;
  left: 0;
}

:host(ids-loading-indicator[linear]) {
  align-items: flex-end;
  height: 48px;
}

:host(ids-loading-indicator[overlay]) {
  z-index: var(--ids-z-index-top-level-container);
}

.progress {
  transition: stroke-dashoffset 0.275s ease-in, transform 0.275s ease-in;
  z-index: 1;
}

.progress-percentage {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 49%;
  transform: translate(-50%, -50%);
  color: var(--ids-loading-indicator-color-text);
}

.progress-percentage.linear {
  top: 50%;
}

.percentage {
  position: relative;
  top: -4px;
  right: -2px;
}

svg.linear-indicator {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--ids-loading-indicator-height);
  overflow: hidden;
}
svg.linear-indicator.sticky {
  height: var(--ids-loading-indicator-height);
}
svg.linear-indicator .progress {
  fill: var(--ids-loading-indicator-progress-color, transparent);
  transform: scaleX(calc(var(--progress) * 1%));
}
svg.linear-indicator .circle {
  fill: var(--ids-loading-indicator-circle-color, transparent);
}

svg.circular-indicator {
  position: relative;
  overflow: visible;
  fill: var(--ids-color-transparent, transparent);
  transform-origin: 50% 50%;
  transform: rotateZ(-90deg);
  display: flex;
  align-items: center;
  justify-content: center;
}
svg.circular-indicator circle {
  transform-origin: 50% 50%;
}
svg.circular-indicator .circle {
  stroke: var(--ids-loading-indicator-circle-color, transparent);
}
svg.circular-indicator .progress {
  stroke-dasharray: 283;
  stroke: var(--ids-loading-indicator-progress-color, transparent);
}

svg.circular-indicator:not(.inline) {
  width: 50px;
  height: 50px;
}

svg.circular-indicator.inline {
  width: 11px;
  height: 11px;
}

.circular-indicator.determinate .progress {
  /*
   * circumference is 2πr(45) => 282.74, or 283
   */
  stroke-dashoffset: calc(283px - (var(--progress) * 2.83));
}

.ai-loading-indicator {
  display: flex;
  position: relative;
  width: 56px;
}

.ai-loading-indicator .bar {
  margin-right: 2px;
  margin-left: 2px;
  background-color: var(--ids-loading-indicator-ai-color-background-default, transparent);
  width: 16px;
  height: 8px;
  border-radius: 8px;
  transition: 0.2s;
  animation: loading 1.2s ease-in-out 0.2s infinite;
}

.ai-loading-indicator .bar:nth-child(1) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-one, transparent);
  animation-delay: 0s;
}

.ai-loading-indicator .bar:nth-child(2) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-two, transparent);
  animation-delay: 0.14s;
}

.ai-loading-indicator .bar:nth-child(3) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-three, transparent);
  animation-delay: 0.42s;
}

@keyframes indeterminate-spinner-progress-anim {
  0%, 15% {
    stroke-dashoffset: 272;
    transform: rotate(0);
  }
  60% {
    stroke-dashoffset: 80;
    transform: rotate(45deg);
  }
  65% {
    stroke-dashoffset: 80;
    transform: rotate(45deg);
  }
  100% {
    stroke-dashoffset: 272;
    transform: rotate(360deg);
  }
}
@keyframes indeterminate-spinner-anim {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
svg.circular-indicator.indeterminate .progress {
  animation: 1.52s linear infinite both indeterminate-spinner-progress-anim;
}

svg.circular-indicator.indeterminate {
  animation: 2.4s linear infinite indeterminate-spinner-anim;
}

svg.linear-indicator.indeterminate .progress {
  animation: 2.8s linear infinite both indeterminate-linear-progress-anim;
}

@keyframes indeterminate-linear-progress-anim {
  0% {
    transform: translateX(0%) scaleX(0.0001);
  }
  3.125%, 53.125% {
    transform: translateX(0%) scaleX(0.2);
  }
  6.25% {
    transform: translateX(20%) scaleX(0.3);
  }
  12.5%, 62.5% {
    transform: translateX(60%) scaleX(0.45);
  }
  25%, 75% {
    transform: translateX(100%) scaleX(1);
  }
  25.0001%, 50%, 75.0001%, 100% {
    transform: translateX(0%) scaleX(0.0001);
  }
}
@keyframes loading {
  0% {
    height: 8px;
  }
  50% {
    width: 56px;
  }
  100% {
    height: 8px;
  }
}
:host([size=xs]:not([linear]):not([sticky]):not([inline])), :host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(container) {
  width: 15px;
  height: 15px;
}
:host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(circle) {
  stroke-width: 12;
}
:host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(progress) {
  stroke-width: 21;
}

:host(.type-primary)::part(circle) {
  stroke: var(--ids-loading-indicator-primary-circle-stroke, transparent);
}
:host(.type-primary)::part(progress) {
  stroke: var(--ids-loading-indicator-primary-progress-color-border, transparent);
}

:host(.type-primary-destructive)::part(progress) {
  stroke: var(--ids-loading-indicator-primary-destructive-progress-color-border, transparent);
}
:host(.type-primary-destructive)::part(circle) {
  stroke: var(--ids-loading-indicator-primary-destructive-circle-stroke, transparent);
}

:host(.type-tertiary-destructive)::part(progress) {
  stroke: var(--ids-loading-indicator-destructive-progress-color-border, transparent);
}
:host(.type-tertiary-destructive)::part(circle) {
  stroke: var(--ids-loading-indicator-tertiary-destructive-circle-stroke, transparent);
}

ids-loading-indicator[contained][overlay] {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.loading-container {
  position: relative;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-loading-indicator/ids-loading-indicator.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,0BAAA;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAGA;EACE,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAAF;;AAIA;;;EAGE,aAAA;AADF;;AAIA;;EAEE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AADF;;AAIA;EACE,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;AADF;;AAIA;EACE,qBAAA;EACA,YAAA;AADF;;AAIA;EAEE,+CAAA;AAFF;;AAKA;EACE,sEAAA;EACA,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,8CAAA;AAFF;;AAKA;EACE,QAAA;AAFF;;AAKA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;EACA,gBAAA;AAFF;AAIE;EACE,2CAAA;AAFJ;AAKE;EACE,8DAAA;EACA,6CAAA;AAHJ;AAME;EACE,4DAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,iBAAA;EACA,+CAAA;EACA,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;AAOE;EACE,yBAAA;AALJ;AAQE;EACE,8DAAA;AANJ;AASE;EACE,qBAAA;EACA,gEAAA;AAPJ;;AAWA;EACE,WAAA;EACA,YAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;AARF;;AAWA;EACE;;IAAA;EAGA,yDAAA;AARF;;AAYA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;AATF;;AAYA;EACE,iBAAA;EACA,gBAAA;EACA,uFAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AATF;;AAYA;EACE,uFAAA;EACA,mBAAA;AATF;;AAYA;EACE,uFAAA;EACA,sBAAA;AATF;;AAYA;EACE,yFAAA;EACA,sBAAA;AATF;;AAYA;EACE;IAEE,sBAAA;IACA,oBAAA;EAVF;EAaA;IACE,qBAAA;IACA,wBAAA;EAXF;EAcA;IACE,qBAAA;IACA,wBAAA;EAZF;EAeA;IACE,sBAAA;IACA,yBAAA;EAbF;AACF;AAgBA;EACE;IACE,wBAAA;EAdF;EAiBA;IACE,0BAAA;EAfF;AACF;AAkBA;EACE,yEAAA;AAhBF;;AAmBA;EACE,0DAAA;AAhBF;;AAmBA;EACE,uEAAA;AAhBF;;AAmBA;EACE;IACE,wCAAA;EAhBF;EAmBA;IAEE,qCAAA;EAlBF;EAqBA;IACE,sCAAA;EAnBF;EAsBA;IAEE,uCAAA;EArBF;EAwBA;IAEE,qCAAA;EAvBF;EA0BA;IAIE,wCAAA;EA3BF;AACF;AA8BA;EACE;IACE,WAAA;EA5BF;EA+BA;IACE,WAAA;EA7BF;EAgCA;IACE,WAAA;EA9BF;AACF;AAmCE;EAEE,WAAA;EACA,YAAA;AAlCJ;AAqCE;EACE,gBAAA;AAnCJ;AAsCE;EACE,gBAAA;AApCJ;;AA0CE;EACE,uEAAA;AAvCJ;AA0CE;EACE,+EAAA;AAxCJ;;AA6CE;EACE,2FAAA;AA1CJ;AA6CE;EACE,mFAAA;AA3CJ;;AAgDE;EACE,mFAAA;AA7CJ;AAgDE;EACE,oFAAA;AA9CJ;;AAkDA;EACE,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,WAAA;AA/CF;;AAkDA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/CF","sourcesContent":["/* Ids Loading Indicator */\n\n:host(ids-loading-indicator:not([linear]):not([sticky])) {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n:host(ids-loading-indicator:not([linear]):not([sticky]):not([inline])) {\n  width: 50px;\n  height: 50px;\n}\n\n:host(ids-loading-indicator[inline]:not([linear]):not([sticky])) {\n  width: 11px;\n  height: 11px;\n}\n\n// Center alignment\n:host(ids-loading-indicator[align='center']:not([linear]):not([sticky]):not([inline])) {\n  position: fixed;\n  inset-block-start: 50%;\n  inset-inline-start: 50%;\n  margin-block-start: -25px;\n}\n\n:host(ids-loading-indicator[align='center']:not([stopped])[contained]:not([sticky]):not([inline])) {\n  position: absolute;\n  inset-block-start: 0;\n  inset-inline-start: 0;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n}\n\n// Paused/Stopped\n:host(ids-loading-indicator[stopped]:not([linear]):not([sticky])),\n:host(ids-loading-indicator[stopped][linear]),\n:host(ids-loading-indicator[stopped][sticky]) {\n  display: none;\n}\n\n:host(ids-loading-indicator[linear]),\n:host(ids-loading-indicator[sticky]) {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n:host(ids-loading-indicator[sticky]) {\n  position: absolute;\n  align-items: center;\n  top: 0;\n  left: 0;\n}\n\n:host(ids-loading-indicator[linear]) {\n  align-items: flex-end;\n  height: 48px;\n}\n\n:host(ids-loading-indicator[overlay]) {\n  // Should match IdsModuleNavBar z-index\n  z-index: var(--ids-z-index-top-level-container);\n}\n\n.progress {\n  transition: stroke-dashoffset 0.275s ease-in, transform 0.275s ease-in;\n  z-index: 1;\n}\n\n.progress-percentage {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 49%;\n  transform: translate(-50%, -50%);\n  color: var(--ids-loading-indicator-color-text);\n}\n\n.progress-percentage.linear {\n  top: calc(50%);\n}\n\n.percentage {\n  position: relative;\n  top: -4px;\n  right: -2px;\n}\n\nsvg.linear-indicator {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: var(--ids-loading-indicator-height);\n  overflow: hidden;\n\n  &.sticky {\n    height: var(--ids-loading-indicator-height);\n  }\n\n  .progress {\n    fill: var(--ids-loading-indicator-progress-color, transparent);\n    transform: #{'scaleX(calc(var(--progress) * 1%))'};\n  }\n\n  .circle {\n    fill: var(--ids-loading-indicator-circle-color, transparent);\n  }\n}\n\nsvg.circular-indicator {\n  position: relative;\n  overflow: visible;\n  fill: var(--ids-color-transparent, transparent);\n  transform-origin: 50% 50%;\n  transform: rotateZ(-90deg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  circle {\n    transform-origin: 50% 50%;\n  }\n\n  .circle {\n    stroke: var(--ids-loading-indicator-circle-color, transparent);\n  }\n\n  .progress {\n    stroke-dasharray: 283;\n    stroke: var(--ids-loading-indicator-progress-color, transparent);\n  }\n}\n\nsvg.circular-indicator:not(.inline) {\n  width: 50px;\n  height: 50px;\n}\n\nsvg.circular-indicator.inline {\n  width: 11px;\n  height: 11px;\n}\n\n.circular-indicator.determinate .progress {\n  /*\n   * circumference is 2πr(45) => 282.74, or 283\n   */\n  stroke-dashoffset: #{'calc(283px - (var(--progress) * 2.83))'};\n}\n\n// Genartive AI Loading Indicator\n.ai-loading-indicator {\n  display: flex;\n  position: relative;\n  width: 56px;\n}\n\n.ai-loading-indicator .bar {\n  margin-right: 2px;\n  margin-left: 2px;\n  background-color: var(--ids-loading-indicator-ai-color-background-default, transparent);\n  width: 16px;\n  height: 8px;\n  border-radius: 8px;\n  transition: 0.2s;\n  animation: loading 1.2s ease-in-out 0.2s infinite;\n}\n\n.ai-loading-indicator .bar:nth-child(1) {\n  background-color: var( --ids-loading-indicator-ai-color-background-bar-one, transparent);\n  animation-delay: 0s;\n}\n\n.ai-loading-indicator .bar:nth-child(2) {\n  background-color: var( --ids-loading-indicator-ai-color-background-bar-two, transparent);\n  animation-delay: 0.14s;\n}\n\n.ai-loading-indicator .bar:nth-child(3) {\n  background-color: var( --ids-loading-indicator-ai-color-background-bar-three, transparent);\n  animation-delay: 0.42s;\n}\n\n@keyframes indeterminate-spinner-progress-anim {\n  0%,\n  15% {\n    stroke-dashoffset: 272;\n    transform: rotate(0);\n  }\n\n  60% {\n    stroke-dashoffset: 80;\n    transform: rotate(45deg);\n  }\n\n  65% {\n    stroke-dashoffset: 80;\n    transform: rotate(45deg);\n  }\n\n  100% {\n    stroke-dashoffset: 272;\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes indeterminate-spinner-anim {\n  0% {\n    transform: rotateZ(0deg);\n  }\n\n  100% {\n    transform: rotateZ(360deg);\n  }\n}\n\nsvg.circular-indicator.indeterminate .progress {\n  animation: 1.52s linear infinite both indeterminate-spinner-progress-anim;\n}\n\nsvg.circular-indicator.indeterminate {\n  animation: 2.4s linear infinite indeterminate-spinner-anim;\n}\n\nsvg.linear-indicator.indeterminate .progress {\n  animation: 2.8s linear infinite both indeterminate-linear-progress-anim;\n}\n\n@keyframes indeterminate-linear-progress-anim {\n  0% {\n    transform: translateX(0%) scaleX(0.0001);\n  }\n\n  3.125%,\n  53.125% {\n    transform: translateX(0%) scaleX(0.2);\n  }\n\n  6.25% {\n    transform: translateX(20%) scaleX(0.3);\n  }\n\n  12.5%,\n  62.5% {\n    transform: translateX(60%) scaleX(0.45);\n  }\n\n  25%,\n  75% {\n    transform: translateX(100%) scaleX(1);\n  }\n\n  25.0001%,\n  50%,\n  75.0001%,\n  100% {\n    transform: translateX(0%) scaleX(0.0001);\n  }\n}\n\n@keyframes loading {\n  0% {\n    height: 8px;\n  }\n\n  50% {\n    width: 56px;\n  }\n\n  100% {\n    height: 8px;\n  }\n}\n\n// Sizes\n:host([size='xs']:not([linear]):not([sticky]):not([inline])) {\n  &,\n  &::part(container) {\n    width: 15px;\n    height: 15px;\n  }\n\n  &::part(circle) {\n    stroke-width: 12;\n  }\n\n  &::part(progress) {\n    stroke-width: 21;\n  }\n}\n\n// Slotted in other components\n:host(.type-primary) {\n  &::part(circle) {\n    stroke: var(--ids-loading-indicator-primary-circle-stroke, transparent);\n  }\n\n  &::part(progress) {\n    stroke: var(--ids-loading-indicator-primary-progress-color-border, transparent);\n  }\n}\n\n:host(.type-primary-destructive) {\n  &::part(progress) {\n    stroke: var(--ids-loading-indicator-primary-destructive-progress-color-border, transparent);\n  }\n\n  &::part(circle) {\n    stroke: var(--ids-loading-indicator-primary-destructive-circle-stroke, transparent);\n  }\n}\n\n:host(.type-tertiary-destructive) {\n  &::part(progress) {\n    stroke: var(--ids-loading-indicator-destructive-progress-color-border, transparent);\n  }\n\n  &::part(circle) {\n    stroke: var(--ids-loading-indicator-tertiary-destructive-circle-stroke, transparent);\n  }\n}\n\nids-loading-indicator[contained][overlay] {\n  position: absolute;\n  inset-block-start: 50%;\n  inset-inline-start: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\n.loading-container {\n  position: relative;\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
